import React from 'external/react';
import PropTypes from 'external/prop-types';
import { Table } from 'external/react-bootstrap';
import TimeLineItem from './ChangeRecords/TimeLineItem';
import TimeLineItemMessageHeader from './ChangeRecords/TimeLineItemMessageHeader';
import { HtmlTextRenderer } from './ChangeRecords/HtmlTextRenderer';

const WebcamJournalRenderer = ({ message, entry }) => {
    const { userMeta, timestamp } = entry;
    const { description, title, url } = message;
    const image = entry.attachments.image;

    return (
        <TimeLineItem userMeta={userMeta} timestamp={timestamp}>
            <TimeLineItemMessageHeader>
                <strong>
                    {title}
                </strong>
            </TimeLineItemMessageHeader>

            <div className="my-3">
                <Table
                    className="journal-entry-records-table"
                    responsive
                    borderless
                    size="sm"
                >
                    <tbody>
                    <tr>
                        <td>Kommentar</td>
                        <td><HtmlTextRenderer text={description}/></td>
                    </tr>
                    <tr>
                        <td>Quelle</td>
                        <td>{url}</td>
                    </tr>
                    </tbody>
                </Table>
                <img src={image} loading="lazy"/>
            </div>
        </TimeLineItem>
    );
};

WebcamJournalRenderer.propTypes = {
    message: PropTypes.object.isRequired,
    entry: PropTypes.object.isRequired
};

export default WebcamJournalRenderer;



// WEBPACK FOOTER //
// ./js/components/WebcamJournalRenderer.jsx